import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, resolveDirective as _resolveDirective, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col-12 col-md-12 col-lg-9 order-1 order-md-2 mb-4 mb-md-0" }
const _hoisted_2 = { class: "card vt-news-card breadcrumb-card mb-3" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { "aria-label": "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = {
  key: 0,
  class: "place-button"
}
const _hoisted_9 = { class: "btn btn-primary" }
const _hoisted_10 = { class: "card p-3" }
const _hoisted_11 = { class: "flex gap-3 mb-3" }
const _hoisted_12 = { class: "w-full md:w-1/4" }
const _hoisted_13 = { for: "search" }
const _hoisted_14 = {
  key: 0,
  class: "p-1 rounded btn-success m-1"
}
const _hoisted_15 = {
  key: 1,
  class: "p-1 rounded btn-danger m-1"
}
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons size-font-ahalf" }, " edit ", -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  alt: "image",
  class: "w-[50px]"
}
const _hoisted_20 = { class: "customize-footer flex flex-row-reverse" }
const _hoisted_21 = { class: "customize-rows-per-page m-2" }
const _hoisted_22 = ["selected", "value"]
const _hoisted_23 = { class: "customize-index m-2 p-2" }
const _hoisted_24 = { class: "customize-buttons mt-2 p-1 border flex rounded" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "customize-pagination flex-grow" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]

import {useApi} from '../../utils/api';
  import { onMounted, ref, watch } from "vue";
  import jalaliMoment from 'moment-jalaali';
  import type { Header, Item, HeaderItemClassNameFunction, BodyItemClassNameFunction } from "vue3-easy-data-table";
  import { usePagination, useRowsPerPage } from "use-vue3-easy-data-table";
  import type { UsePaginationReturn, UseRowsPerPageReturn } from "use-vue3-easy-data-table";
  import { useToast } from "vue-toast-notification";
  import { useAuthStore } from '../../stores/auth';
  import { useI18n } from "vue-i18n";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

 
  const { t } = useI18n();
  const authStore = useAuthStore();
  const hasShowPermission = ref(authStore.permissions.includes('country_show'));
  const hasUpdatePermission = ref(authStore.permissions.includes('country_update'));
  const hasDeletePermission = ref(authStore.permissions.includes('country_delete')); 

  
    const dataTable = ref();

    const {
    currentPageFirstIndex,
    currentPageLastIndex,
    clientItemsLength,
    maxPaginationNumber,
    currentPaginationNumber,
    isFirstPage,
    isLastPage,
    nextPage,
    prevPage,
    updatePage,
  }: UsePaginationReturn = usePagination(dataTable);

  const {
    rowsPerPageOptions,
    rowsPerPageActiveOption,
    updateRowsPerPageActiveOption,
  }: UseRowsPerPageReturn = useRowsPerPage(dataTable);

  const updateRowsPerPageSelect = (e: Event) => {
    updateRowsPerPageActiveOption(Number((e.target as HTMLInputElement).value));
  };


  const searchField = ref("title");
  const searchValue = ref("");
  const headers: Header[] = [
    { text: t("site.Id"), value: "id", sortable: true},
    { text: t('site.Title'), value: "title" },
    // { text: t('site.User'), value: "user_id" },
    { text: t('site.Image'), value: "image", sortable: true },
    { text: t('site.Status'), value: "status", sortable: true },
    { text: t('site.Date'), value: "created_at" },
    { text: t('site.Manage'), value: "actions" },
  ];
  
  const items = ref<Item[]>([]);
  
  const loading = ref(false);
  const serverItemsLength = ref(0);
  const serverOptions = ref({
    page: 1,
    rowsPerPage: 25,
    sortBy: 'id',
    sortType: 'desc',
    query: '',
  });

  const headerItemClassNameFunction: HeaderItemClassNameFunction = (): string => {
    return 'vt-bg-text';
  };

  const bodyItemClassNameFunction: BodyItemClassNameFunction = (): string => {   
    return 'direction-right';
  };
  
  const loadFromServer = async () => {
    loading.value = true;
    await useApi().get('/api/profile/countries', serverOptions.value)
    .then((response: any) => {
        items.value = response.data.data;
        serverItemsLength.value = response.data.total;
    })
    loading.value = false;
  };

  const $toast = useToast();
  const deletItem = (id: Number) => {
    if(confirm('Are you sure you want to remove this item?')) {
        useApi().deleteRequest(`/api/profile/countries/${id}`)
        .then((response: any) => {
            if (response.data.status) {

                $toast.success(response.data.message);
                loadFromServer();
            }
        })
    }
  };
  
  // initial load
  loadFromServer();
  
  watch(serverOptions, () => { loadFromServer(); }, { deep: true });

  onMounted(() => {

    window.document.title =   `${t('site.Country management')} | ${t('site.Website name')}`;
  })


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("ol", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/profile",
                title: _ctx.$t('site.Profile')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('site.Profile')), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _createElementVNode("li", _hoisted_7, _toDisplayString(_ctx.$t('site.Country management')), 1)
          ])
        ]),
        (hasShowPermission.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: "/profile/countries/create",
                title: _ctx.$t('site.Create new country')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.$t('site.Create new country')), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('site.Search')), 1),
          _withDirectives(_createElementVNode("input", {
            name: "serach",
            class: "form-control is-vt",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((serverOptions.value.query) = $event))
          }, null, 512), [
            [
              _vModelText,
              serverOptions.value.query,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createVNode(_component_EasyDataTable, {
        ref_key: "dataTable",
        ref: dataTable,
        "server-options": serverOptions.value,
        "onUpdate:serverOptions": _cache[1] || (_cache[1] = ($event: any) => ((serverOptions).value = $event)),
        "server-items-length": serverItemsLength.value,
        loading: loading.value,
        headers: headers,
        items: items.value,
        "show-index": "",
        "search-field": searchField.value,
        "search-value": searchValue.value,
        "header-item-class-name": headerItemClassNameFunction,
        "body-item-class-name": bodyItemClassNameFunction,
        "hide-footer": "",
        "border-cell": "",
        alternating: ""
      }, {
        "item-status": _withCtx((item) => [
          (item.status == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('site.Active')), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('site.Inactive')), 1))
        ]),
        "item-actions": _withCtx((item) => [
          _createElementVNode("div", _hoisted_16, [
            (hasUpdatePermission.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "p-1 rounded btn-info m-1 text-white",
                  to: '/profile/countries/' + item.id
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true),
            (hasDeletePermission.value)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  onClick: ($event: any) => (deletItem(item.id)),
                  class: "p-1 rounded btn-danger m-1 text-white material-icons size-font-ahalf cursor-pointer"
                }, " delete ", 8, _hoisted_18))
              : _createCommentVNode("", true)
          ])
        ]),
        "item-image": _withCtx((item) => [
          (item?.image?.length > 0)
            ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_19, null, 512)), [
                [_directive_lazy, item.image]
              ])
            : _createCommentVNode("", true)
        ]),
        "item-created_at": _withCtx((item) => [
          _createTextVNode(_toDisplayString(_unref(jalaliMoment)(item.created_at).format('jYYYY-jMM-jDD')), 1)
        ]),
        "empty-message": _withCtx(() => [
          _createElementVNode("a", null, _toDisplayString(_ctx.$t('site.nothing here')), 1)
        ]),
        _: 1
      }, 8, ["server-options", "server-items-length", "loading", "items", "search-field", "search-value"]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("select", {
            class: "select-items btn bg-primary text-white",
            onChange: updateRowsPerPageSelect
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rowsPerPageOptions), (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item,
                selected: item === _unref(rowsPerPageActiveOption),
                value: item
              }, _toDisplayString(item), 9, _hoisted_22))
            }), 128))
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_23, " نمایش سطرهای: " + _toDisplayString(_unref(currentPageFirstIndex)) + " ~ " + _toDisplayString(_unref(currentPageLastIndex)) + " از " + _toDisplayString(_unref(clientItemsLength)), 1),
        _createElementVNode("div", _hoisted_24, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(maxPaginationNumber), (paginationNumber, key) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
              (
                    _unref(currentPaginationNumber) != undefined &&
                    !(paginationNumber > _unref(currentPaginationNumber) + 2) &&
                    !(paginationNumber < _unref(currentPaginationNumber) - 2))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["customize-button m-1 py-1 px-2 rounded cursor-pointer", {'active': paginationNumber === _unref(currentPaginationNumber)}]),
                    onClick: ($event: any) => (_unref(updatePage)(paginationNumber))
                  }, _toDisplayString(paginationNumber), 11, _hoisted_25))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            class: _normalizeClass({
                    'prev-page m-2 bg-vt rounded p-2 text-white': true,
                    'cursor-pointer': !_unref(isFirstPage),
                    }),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(prevPage) && _unref(prevPage)(...args))),
            disabled: _unref(isFirstPage)
          }, _toDisplayString(_ctx.$t('site.Previous page')), 11, _hoisted_27),
          _createElementVNode("button", {
            class: _normalizeClass({
                    'prev-page m-2 bg-vt rounded p-2 text-white': true,
                    'cursor-pointer': !_unref(isLastPage),
                    }),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(nextPage) && _unref(nextPage)(...args))),
            disabled: _unref(isLastPage)
          }, _toDisplayString(_ctx.$t('site.Next page')), 11, _hoisted_28)
        ])
      ])
    ])
  ]))
}
}

})